import React from 'react'

const TeacherSearch = () => {
  return (
    <div>TeacherSearch</div>
  )
}

export default TeacherSearch